// ─── RSVP: Minimal ────────────────────────────────────────────
// Clean minimal RSVP section without card chrome (legacy). When the
// designer activates any surface control the shell renders a real glass
// wrapper around the form column.

import React from 'react';
import { AnimatedSection } from '../../../lib/animations/AnimatedSection';
import RSVPForm from '../../RSVPTemplates/RSVPForm';
import PreviewModeNotice from './PreviewModeNotice';
import RsvpSurfaceShell from './RsvpSurfaceShell';

export default function RsvpMinimal({ section, data, theme, settings, rsvpRef }) {
  const anim = section.animation || {};
  const cs = data.customStyle || {};
  const bg = data.background;
  const motionPreset = settings?.motionPreset || 'none';
  const disableAnim = motionPreset !== 'none';

  const accentColor = cs.accentColor || theme.accent;
  const titleColor = cs.textColor || theme.textPrimary;
  const descColor = cs.textColor ? `${cs.textColor}99` : theme.textSecondary;
  const headingFont = cs.fontFamily || theme.headingFont;

  return (
    <RsvpSurfaceShell
      cs={cs}
      background={bg}
      naturalMaxWidthRem={20}
      borderRadiusRem={1.25}
      contentPaddingClass="p-6 sm:p-8"
      sectionPaddingClass="px-5 py-24"
      surfaceBgColor={cs.bgColor || undefined}
      surfaceBorderColor={cs.textColor ? `${cs.textColor}20` : theme.border}
      rsvpRef={rsvpRef}
      contentAlign="center"
    >
      <PreviewModeNotice visible={!!settings?.disableRsvpSubmit} />
      <AnimatedSection preset={anim.section || 'fade-up'} disableAnimation={disableAnim}>
        <div className="w-8 h-px mx-auto mb-6" style={{ background: accentColor }} />
        <h2 className="text-2xl font-light mb-2" style={{ color: titleColor, fontFamily: headingFont }}>
          {data.title || 'RSVP'}
        </h2>
        <p className="text-sm mb-10" style={{ color: descColor }}>
          {data.description || "We'd love to know if you can make it"}
        </p>
      </AnimatedSection>
      <AnimatedSection preset={anim.section || 'fade-up'} delay={0.1} disableAnimation={disableAnim}>
        <RSVPForm
          slug={settings.slug}
          accentColor={accentColor}
          labels={data.labels}
          buttonShadowStrength={cs.buttonShadowStrength}
          customStyle={cs}
          disableSubmit={settings?.disableRsvpSubmit}
        />
      </AnimatedSection>
    </RsvpSurfaceShell>
  );
}
